import { useDispatch } from "react-redux";
import { useLazySaveCrossSellConsentQuery } from "../features/Feature_Login/Login_Api";
import { T_CustomerLobDetailObj } from "../features/Feature_Login/Login_Types";
import { E_ChannelOptions } from "../globalTypes/GlobalTypes";
import { useAppSelector } from "../redux-store/CustomReduxHooks";
import { setError } from "../redux-store/reducers/CsErrorSlice";
import { API_STATUS_CODE } from "../utils/ApiEndpoints";
import { ABCChannelSource, DEVICE_TYPE } from "../utils/constants";
import useDeviceDetection from "./useDeviceDetection";
import { isEmpty } from "lodash";

const useSaveCrossSellConsent = () => {
  const appDispatch = useDispatch();
  const [saveCrossSellConsentApi] = useLazySaveCrossSellConsentQuery();
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  let deviceType = useDeviceDetection();
  let channelForConsentApi = "";

  if (
    deviceType === DEVICE_TYPE.ABC_WEB_MOB_CS ||
    deviceType === DEVICE_TYPE.WEB ||
    deviceType === DEVICE_TYPE.PWA_WEB
  ) {
    channelForConsentApi = "Web";
  }
  if (
    deviceType === DEVICE_TYPE.MOBILE ||
    deviceType === DEVICE_TYPE.PWA_MOBILE ||
    !isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName)
  ) {
    channelForConsentApi = "App";
  }
  if (csAppSlice.channel === E_ChannelOptions.SUPER_APP) {
    channelForConsentApi = "ABCDSSO";
  }

  const callSaveCrossSellConsentApi = (
    mobileNumber: string,
    customerAndLobDetails: T_CustomerLobDetailObj[],
  ) => {
    saveCrossSellConsentApi({
      mobileNo: mobileNumber || "",
      email:
        customerAndLobDetails.length === 1
          ? customerAndLobDetails[0].EMAIL
          : "",
      firstName:
        customerAndLobDetails.length === 1 ? customerAndLobDetails[0].NAME : "",
      channel: channelForConsentApi || "",
      appVersion: csAppSlice?.NativeDeviceInfo?.appVersion || "",
      imeiNo: csAppSlice?.NativeDeviceInfo?.bioInfo?.deviceId || "",
      platform: ABCChannelSource[deviceType] || "",
      tncVersion: "1",
    }).then((res) => {
      if (res?.data?.code === API_STATUS_CODE.SUCCESS) {
        return;
      }
    });
  };
  return { callSaveCrossSellConsentApi };
};

export default useSaveCrossSellConsent;
